export default __webpack_public_path__ + "media/images/portfolio/gallery-05-370x220-813db06d53129ad84974a8b3d69c6500.jpg";